module.exports = __webpack_public_path__ + "assets/flea.3330cb69.svg";